<template>
  <div class="all-wrapper menu-side with-pattern">
   <div class="auth-box-w wider">
     <div class="logo-w"><img alt="" src="../../assets/img/onetap_transparent.png" height="90"></div>
      <h4 class="auth-header">Register Now</h4>
      <form @submit="register">
        <div class="alert alert-danger" role="alert" v-if="errors.length" v-for="error in errors">
          {{ error }}
        </div>
        <div class="form-group">
           <label for=""> Full Name</label><input class="form-control" placeholder="Enter full name" type="text" v-model="full_name">
           <div class="pre-icon os-icon os-icon-user-male-circle2"></div>
        </div>
        <div class="form-group">
           <label for=""> Username</label><input class="form-control" placeholder="Enter username" type="text" v-model="username">
           <div class="pre-icon os-icon os-icon-robot-2"></div>
        </div>
         <div class="form-group">
            <label for=""> Email address</label><input class="form-control" placeholder="Enter email address" type="email" v-model="email">
            <div class="pre-icon os-icon os-icon-email-2-at2"></div>
         </div>
         <div class="form-group">
            <label for=""> Password</label><input class="form-control" placeholder="Enter password" type="password" v-model="password">
            <div class="pre-icon os-icon os-icon-fingerprint"></div>
         </div>
         <div class="buttons-w"><button class="btn btn-primary">Register Now</button><router-link class="btn btn-link" to="/auth/login">Registered? Login now</router-link></div>
      </form>
   </div>
 </div>
</template>

<script>
export default {
  name: 'Register',
  metaInfo: {
    title: 'register',
    titleTemplate: 'onetap | %s',
    meta: [
      { property: 'og:title', content: 'onetap | Register' },
      { property: 'og:site_name', content: 'onetap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://onetap.gg/'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'onetap | Register' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      registerBg: [
        require('../../assets/img/de_dust2.jpg'),
      ],
      max: 13,
      image: null,
      errors: [],
      username: null,
      email: null,
      password: null,
      full_name: null
    }
  },
  methods: {
    register: function(e) {
      e.preventDefault();
      this.errors = [];

      if (!this.username) {
        this.errors.push('Username is required!');
        return;
      }

      if (!this.email) {
        this.errors.push('Email is required!');
        return;
      } else if (!this.validEmail(this.email)) {
        this.errors.push(`Are you sure that's the correct email?`);
      }

      if (!this.password) {
        this.errors.push('Password is required!');
        return;
      }

      this.errors.push('Registering, please wait.');

      this.axios.post(`${this.API_URL}/auth/register`, { full_name: this.full_name, username: this.username, email: this.email, password: this.password }).then((res) => {
        this.$root.setAuthTicket(res.data.ticket);
        this.$router.push('/auth/verify');
      }).catch((err) => {
        this.errors = [];
        this.errors.push(err.response.data.message);
      });
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  mounted() {
    //
  },
  created() {
    if (this.$root.isAuthenticated) {
      this.$router.push('/')
    }
    let random = Math.floor(Math.random() * this.registerBg.length);
    this.image = this.registerBg[random];
    window.$('body').removeClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    window.$('body').css('background-image', 'url("' + this.image + '")');
    window.$('body').css('background-size', 'cover');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
